// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.birthdays-wrapper[data-v-1181efe9] {
  display: flex;
  flex-direction: row;
  background-color: var(--blue-bgcolor);
  margin: 10px auto 10px 14px;
  padding: 10px 10px 0 10px;
  border-radius: 10px;
  color: white;
  font-size: 24px;
  max-width: 95%;
}
@-moz-document url-prefix() {
.birthdays-wrapper[data-v-1181efe9] {
    margin: 10px 5px 10px 7px;
}
}
.birthdays[data-v-1181efe9] {
  width: 100%;
  flex-direction: column;
}
.birthdays .header[data-v-1181efe9] {
  display: flex;
  margin: 0 auto 10px -10px;
}
.birthdays .birthdays-list[data-v-1181efe9] {
  position: relative;
  margin: 0;
}
.birthdays .birthdays-list li[data-v-1181efe9]:not(:first-child)::before {
  position: absolute;
  content: ' ';
  margin-left: 5px;
  width: 100%;
  height: 1px;
  background-color: rgba(240, 240, 240, 0.1);
}
.birthdays .icon[data-v-1181efe9] {
  width: 45px;
  height: 45px;
  margin: 5px 10px 0 10px;
}
.birthdays .desc[data-v-1181efe9] {
  display: flex;
  flex-direction: row;
  margin: 15px 3px;
}
.birthdays .content[data-v-1181efe9] {
  background-color: gray;
  display: flex;
  flex-direction: column;
}
.bd-right[data-v-1181efe9] {
  display: flex;
  margin: 0 0 0 auto;
  flex-direction: column;
  font-size: 14px;
  text-align: center;
}
.bd-right .bd-close[data-v-1181efe9] {
  cursor: pointer;
}
.bd-right .bd-space[data-v-1181efe9] {
  flex-grow: 1;
  min-height: 25px;
}
.bd-right .bd-grow[data-v-1181efe9],
.bd-right .bd-shrink[data-v-1181efe9] {
  cursor: pointer;
}
.birthday-item[data-v-1181efe9] {
  cursor: pointer;
  display: flex;
  height: 70px;
}
.birthday-item .birthday-data-wrapper[data-v-1181efe9] {
  display: flex;
  margin: auto 0;
}
.birthday-item .birthday-data-wrapper .birthday-data[data-v-1181efe9] {
  display: flex;
  margin: 5px 0 auto 0;
  flex-direction: column;
}
.birthday-item .birthday-data-wrapper .birthday-data .name[data-v-1181efe9] {
  font-size: 16px;
  margin-left: 10px;
}
.birthday-item .birthday-data-wrapper .birthday-data .date[data-v-1181efe9] {
  font-size: 12px;
  margin-left: 10px;
  color: rgba(220, 220, 220, 0.9);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/Birthdays.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC","sourcesContent":[".birthdays-wrapper[data-v-1181efe9] {\n  display: flex;\n  flex-direction: row;\n  background-color: var(--blue-bgcolor);\n  margin: 10px auto 10px 14px;\n  padding: 10px 10px 0 10px;\n  border-radius: 10px;\n  color: white;\n  font-size: 24px;\n  max-width: 95%;\n}\n@-moz-document url-prefix() {\n.birthdays-wrapper[data-v-1181efe9] {\n    margin: 10px 5px 10px 7px;\n}\n}\n.birthdays[data-v-1181efe9] {\n  width: 100%;\n  flex-direction: column;\n}\n.birthdays .header[data-v-1181efe9] {\n  display: flex;\n  margin: 0 auto 10px -10px;\n}\n.birthdays .birthdays-list[data-v-1181efe9] {\n  position: relative;\n  margin: 0;\n}\n.birthdays .birthdays-list li[data-v-1181efe9]:not(:first-child)::before {\n  position: absolute;\n  content: ' ';\n  margin-left: 5px;\n  width: 100%;\n  height: 1px;\n  background-color: rgba(240, 240, 240, 0.1);\n}\n.birthdays .icon[data-v-1181efe9] {\n  width: 45px;\n  height: 45px;\n  margin: 5px 10px 0 10px;\n}\n.birthdays .desc[data-v-1181efe9] {\n  display: flex;\n  flex-direction: row;\n  margin: 15px 3px;\n}\n.birthdays .content[data-v-1181efe9] {\n  background-color: gray;\n  display: flex;\n  flex-direction: column;\n}\n.bd-right[data-v-1181efe9] {\n  display: flex;\n  margin: 0 0 0 auto;\n  flex-direction: column;\n  font-size: 14px;\n  text-align: center;\n}\n.bd-right .bd-close[data-v-1181efe9] {\n  cursor: pointer;\n}\n.bd-right .bd-space[data-v-1181efe9] {\n  flex-grow: 1;\n  min-height: 25px;\n}\n.bd-right .bd-grow[data-v-1181efe9],\n.bd-right .bd-shrink[data-v-1181efe9] {\n  cursor: pointer;\n}\n.birthday-item[data-v-1181efe9] {\n  cursor: pointer;\n  display: flex;\n  height: 70px;\n}\n.birthday-item .birthday-data-wrapper[data-v-1181efe9] {\n  display: flex;\n  margin: auto 0;\n}\n.birthday-item .birthday-data-wrapper .birthday-data[data-v-1181efe9] {\n  display: flex;\n  margin: 5px 0 auto 0;\n  flex-direction: column;\n}\n.birthday-item .birthday-data-wrapper .birthday-data .name[data-v-1181efe9] {\n  font-size: 16px;\n  margin-left: 10px;\n}\n.birthday-item .birthday-data-wrapper .birthday-data .date[data-v-1181efe9] {\n  font-size: 12px;\n  margin-left: 10px;\n  color: rgba(220, 220, 220, 0.9);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
